import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton, Paper } from "@mui/material";
import { Close } from "@mui/icons-material";
import apiService from "../../../service/Api";
import type { SiteVisitVenue } from "../../venues/view-venue-v2/site-visit/site-visit.types";
import ScheduleSiteVisitModal from "../../venues/view-venue-v2/site-visit/ScheduleSiteVisitModal";

interface SiteVisitApiItem {
  id: number;
  status: string;
}

interface ApiResponse {
  results: SiteVisitApiItem[];
}

interface SiteVisitBannerProps {
  venueId?: number;
  venue: SiteVisitVenue;
}

const SiteVisitBanner: React.FC<SiteVisitBannerProps> = ({ venueId, venue }) => {
  const [dismissed, setDismissed] = useState(false);
  const [hasSiteVisit, setHasSiteVisit] = useState(true);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (venueId == null) {
      setLoading(false);
      return;
    }

    apiService
      .get<ApiResponse>("/api/venues/site-visit/", { venue: venueId })
      .then((res) => {
        setHasSiteVisit((res.data?.results ?? []).length > 0);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [venueId]);

  if (loading || dismissed || hasSiteVisit || venueId == null) return null;

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          mb: 2,
          p: 2,
          borderRadius: "16px",
          backgroundColor: "#FFF8F2",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body1" fontWeight={700} sx={{ color: "#8b6914", mb: 0.25 }}>
            No site visit done for the venue
          </Typography>
          <Typography variant="body2" sx={{ color: "#7a6030" }}>
            A site visit helps ensure the venue is ready for the event. Schedule one now.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
          <Button
            variant="contained"
            onClick={() => setModalOpen(true)}
            sx={{
              backgroundColor: "#C59A70",
              color: "#fff",
              borderRadius: "10px",
              boxShadow: 0,
              px: 2,
              py: 1,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#deb58d" },
            }}
          >
            Do Site Visit
          </Button>

          <IconButton size="small" onClick={() => setDismissed(true)}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
      </Paper>

      <ScheduleSiteVisitModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        venueId={venueId}
        venue={venue}
        onSuccess={() => {
          setModalOpen(false);
          setDismissed(true);
        }}
      />
    </>
  );
};

export default SiteVisitBanner;
